var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPage1Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 505,
    height: 2,
    viewBox: "0 0 505 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 0.99798,
    x2: 504.939,
    y2: 0.99798,
    stroke: "black",
    strokeWidth: 0.472789
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage1Line);
export default __webpack_public_path__ + "static/media/page_1_line.6cfd22130cb3180f801a20cf645fc4f6.svg";
export { ForwardRef as ReactComponent };